import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const storekeeperRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@pages/storekeeper/store-dashboard/store-dashboard').then(
        (m) => m.StoreDashboard,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  {
    path: 'resource-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/resource-management').then(
        (m) => m.ResourceManagement,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'storekeeper',
    },
  },

  {
    path: 'resource-management/add-device/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/add-device/add-device').then(
        (m) => m.AddDevice,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'storekeeper',
    },
  },
  {
    path: 'resource-management/add-device',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/add-device/add-device').then(
        (m) => m.AddDevice,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'storekeeper',
    },
  },
  {
    path: 'resource-management/device-bulk-upload',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/device-bulk-upload/device-bulk-upload').then(
        (m) => m.DeviceBulkUpload,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'storekeeper',
    },
  },
  {
    //pass id in route
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    path: 'resource-management/device-details/:id',
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/device-details/device-details').then(
        (m) => m.DeviceDetails,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'storekeeper',
    },
  },
  {
    path: 'request-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/request-management/request-management').then(
        (m) => m.RequestManagement,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'storekeeper',
    },
  },
];
